import { render, staticRenderFns } from "./TabsStatus.vue?vue&type=template&id=97ba4bb6&scoped=true&"
import script from "./TabsStatus.vue?vue&type=script&lang=js&"
export * from "./TabsStatus.vue?vue&type=script&lang=js&"
import style0 from "./TabsStatus.vue?vue&type=style&index=0&id=97ba4bb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97ba4bb6",
  null
  
)

export default component.exports